import type { ReactNode } from "react";
import {
  IconNameEnum,
  useModuleBEM,
  useUiStyles,
} from "@b2bportal/core-themes";
import {
  CoreUiComponents,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./NotificationBanner.module.scss";

export interface NotificationBannerComponentProps
  extends PlatformComponentProps {
  action?: ReactNode;
  title: string | ReactNode;
  subtitle?: string;
  className?: string;
  iconName?: IconNameEnum;
  onClose?: () => void;
}

export const NotificationBanner = ({
  action,
  title,
  subtitle,
  className,
  iconName,
  onClose,
}: NotificationBannerComponentProps) => {
  const COMPONENT_KEY = CoreUiComponents.NotificationBanner;
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={clsx(block, className)}>
      {iconName ? (
        <Icon className={cn("banner-icon")} iconName={iconName} />
      ) : null}
      <div className={cn("content")}>
        <div className={cn("title")}>{title}</div>
        {subtitle ? <div className={cn("subtitle")}>{subtitle}</div> : null}
        {action ? <div className={cn("action")}>{action}</div> : null}
      </div>
      {onClose ? (
        <button className={cn("close-button")} onClick={onClose}>
          <Icon iconName={IconNameEnum.close} />
        </button>
      ) : null}
    </div>
  );
};
